<template>
    <div class="wrapper">
        <v-container
            class="px-7 py-7 container"
            :class="{ 'pl-10 pr-10 pt-10 pb-5': $vuetify.breakpoint.mdAndUp }"
        >
            <v-layout class="ma-0 pa-0">
                <v-flex>
                    <v-row class="mx-0 mb-4" :class="{ 'h1-26': !$vuetify.breakpoint.mdAndUp }">
                        <h1> Tarkastukset</h1>
                    </v-row>

                    <div>
                        <v-data-table
                            :headers="headers1"
                            :items="inspections"
                            hide-default-footer
                            disable-pagination
                            :sort-by="['userRole']"
                            mobile-breakpoint="0"
                            @click:row="openItem"
                        >
                            <template v-slot:item.address="{ item }">
                                <span data-cy="userName" class="pl-2">
                                    {{ item.address + " " + item.apartment }}
                                </span>
                            </template>
                            <template v-slot:item.status="{ item }">
                                <v-chip
                                    :color="item.status === 'Kesken' ?
                                        '#FAFFDE' : '#E3FFDE'" >
                                    <v-icon v-if="item.status === 'Kesken'" class="mr-2">mdi-clock</v-icon>
                                    <v-icon v-else class="mr-2">mdi-checkbox-marked-circle</v-icon>
                                    {{item.status}}
                                </v-chip>
                            </template>
                        </v-data-table>
                    </div>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>
<script>
import { inspectionsTableDEMO, inspections } from '../fbInitialize';

export default {
    components: {
    },
    data() {
        return {
            inspections: []
        };
    },
    methods: {
        navigateBack() {
            this.$router.push({ name: 'dashboard' });
        },
        openItem(item) {
            this.$router.push({
                name: 'inspection',
                params: { inpectionId: item.id }
            });
        },
    },
    computed: {
        headers1() {
            return [
                {
                    text: 'Asunto',
                    align: 'start',
                    value: 'address',
                    width: '75%',
                },
                {
                    text: 'Status',
                    value: 'status',
                    sortable: false,
                },
            ];
        }
    },
    async created() {
        window.scrollTo(0, 0);
        const inspectionFetch = await inspectionsTableDEMO.doc(this.$route.params.inspectionsId).get();
        const inspectionData = inspectionFetch.data();

        for (const id of inspectionData.inspections) {
            const inspectionFetch = await inspections.doc(id).get();
            const inspection = inspectionFetch.data();
            this.inspections.push(inspection);
        }
    }
};
</script>
